export const AtlassianAnalyticsLogoInverse = () => (
  <svg
    width="477"
    height="48"
    viewBox="0 0 477 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1052_8380)">
      <path
        d="M106.72 18.17C106.72 22.37 108.67 25.71 116.29 27.18C120.84 28.13 121.79 28.87 121.79 30.38C121.79 31.89 120.84 32.81 117.63 32.81C113.91 32.81 109.49 31.55 106.59 29.82V36.66C108.89 37.79 111.92 39.04 117.55 39.04C125.52 39.04 128.68 35.49 128.68 30.2M128.68 30.2C128.68 25.22 126.04 22.88 118.59 21.28C114.48 20.37 113.48 19.46 113.48 18.16C113.48 16.51 114.95 15.82 117.68 15.82C120.97 15.82 124.22 16.82 127.29 18.2V11.66C125.12 10.58 121.79 9.70996 117.89 9.70996C110.53 9.70996 106.72 12.91 106.72 18.16"
        fill="white"
      />
      <path
        d="M209.1 10.1602V38.6102H215.16V16.9102L217.72 22.6702L226.29 38.6102H233.92V10.1602H227.85V28.5202L225.56 23.1902L218.67 10.1602H209.1Z"
        fill="white"
      />
      <path d="M170.54 10.1602H163.91V38.6102H170.54V10.1602Z" fill="white" />
      <path
        d="M156.26 30.2097C156.26 25.2297 153.62 22.8897 146.17 21.2897C142.06 20.3797 141.06 19.4697 141.06 18.1697C141.06 16.5197 142.53 15.8297 145.26 15.8297C148.55 15.8297 151.8 16.8297 154.87 18.2097V11.6697C152.7 10.5897 149.37 9.71973 145.47 9.71973C138.11 9.71973 134.3 12.9197 134.3 18.1697C134.3 22.3697 136.25 25.7097 143.87 27.1797C148.42 28.1297 149.37 28.8697 149.37 30.3797C149.37 31.8897 148.42 32.8097 145.21 32.8097C141.49 32.8097 137.07 31.5497 134.17 29.8197V36.6597C136.47 37.7897 139.5 39.0397 145.13 39.0397C153.1 39.0397 156.26 35.4897 156.26 30.1997"
        fill="white"
      />
      <path
        d="M55.24 10.1602V38.6102H68.86L71.01 32.4602H61.91V10.1602H55.24Z"
        fill="white"
      />
      <path
        d="M28.33 10.1602V16.3102H35.7V38.6102H42.37V16.3102H50.25V10.1602H28.33Z"
        fill="white"
      />
      <path
        d="M18.66 10.1602H9.92L0 38.6102H7.58L8.99 33.8202C10.67 34.3102 12.45 34.5802 14.3 34.5802C16.15 34.5802 17.92 34.3102 19.61 33.8202L21.02 38.6102H28.6L18.66 10.1602ZM14.29 28.6902C13.02 28.6902 11.8 28.5002 10.64 28.1702L14.29 15.7502L17.94 28.1702C16.78 28.5102 15.56 28.6902 14.29 28.6902Z"
        fill="white"
      />
      <path
        d="M92.34 10.1602H83.6L73.68 38.6102H81.26L82.67 33.8202C84.35 34.3102 86.13 34.5802 87.98 34.5802C89.83 34.5802 91.6 34.3102 93.29 33.8202L94.7 38.6102H102.28L92.36 10.1602H92.34ZM87.97 28.6902C86.7 28.6902 85.48 28.5002 84.32 28.1702L87.97 15.7502L91.62 28.1702C90.46 28.5102 89.24 28.6902 87.97 28.6902Z"
        fill="white"
      />
      <path
        d="M194.41 10.1602H185.67L175.75 38.6102H183.33L184.74 33.8202C186.42 34.3102 188.2 34.5802 190.05 34.5802C191.9 34.5802 193.67 34.3102 195.36 33.8202L196.77 38.6102H204.35L194.43 10.1602H194.41ZM190.04 28.6902C188.77 28.6902 187.55 28.5002 186.39 28.1702L190.04 15.7502L193.69 28.1702C192.53 28.5102 191.31 28.6902 190.04 28.6902Z"
        fill="white"
      />
      <path
        d="M254.78 31.7999L252.25 38.6099H247.6L259.52 8.37988H264.76L276.68 38.6099H272.03L269.5 31.7599C266.79 32.3099 264.44 32.5899 262 32.5899C259.7 32.5899 257.35 32.3099 254.78 31.8099V31.7999ZM268.26 28.2999L262.14 11.7399L256.02 28.3499C258.27 28.7199 260.16 28.8999 262 28.8999C263.93 28.8999 265.91 28.6699 268.26 28.2999Z"
        fill="white"
      />
      <path
        d="M298.98 38.6096H295.02V24.7196C295.02 20.5796 293.36 18.7396 289.59 18.7396C285.82 18.7396 283.38 21.1796 283.38 25.8196V38.6096H279.42V15.5996H283.38V19.3696C284.85 16.6596 287.57 15.1396 290.65 15.1396C295.94 15.1396 298.98 18.7696 298.98 25.1196V38.5996V38.6096Z"
        fill="white"
      />
      <path
        d="M320.1 34.4699C318.63 37.5099 315.87 39.0699 312.33 39.0699C306.21 39.0699 303.13 33.8699 303.13 27.1099C303.13 20.3499 306.35 15.1499 312.79 15.1499C316.15 15.1499 318.72 16.6699 320.1 19.6599V15.6099H324.06V38.6099H320.1V34.4699ZM313.38 35.3899C316.92 35.3899 320.1 33.1399 320.1 28.0299V26.1899C320.1 21.0799 317.2 18.8299 313.84 18.8299C309.38 18.8299 307.08 21.7699 307.08 27.1099C307.08 32.4499 309.29 35.3899 313.38 35.3899Z"
        fill="white"
      />
      <path
        d="M336.2 38.7397C332.43 38.7397 330.03 36.9497 330.03 32.7097V5.98975H333.99V32.2597C333.99 34.3297 335.37 35.0697 337.07 35.0697C337.48 35.0697 337.76 35.0697 338.22 35.0197V38.5597C337.9 38.6497 337.21 38.7397 336.2 38.7397Z"
        fill="white"
      />
      <path
        d="M347.33 37.1296L339 15.5996H343.23L350.59 35.2896L357.95 15.5996H362.18L353.49 37.8696C350.91 44.4496 349.44 47.8496 343.6 47.8496C341.62 47.8496 340.52 47.6696 339.37 47.2096V43.8096C340.7 44.2196 342.22 44.3596 343.37 44.3596C346.59 44.3596 348.02 42.1496 349.9 37.1396H347.32L347.33 37.1296Z"
        fill="white"
      />
      <path
        d="M374.7 34.88C375.62 34.88 376.49 34.7 377.18 34.56V38.38C376.49 38.56 375.71 38.75 374.51 38.75C369.59 38.75 367.2 35.85 367.2 31.57V19.29H363.47V15.61H367.2V10.73H371.06V15.61H377.18V19.29H371.06V31.48C371.06 33.5 372.26 34.88 374.69 34.88H374.7Z"
        fill="white"
      />
      <path
        d="M384.26 6.76953C385.87 6.76953 387.02 7.77953 387.02 9.52953C387.02 11.2795 385.87 12.2895 384.26 12.2895C382.65 12.2895 381.5 11.2795 381.5 9.52953C381.5 7.77953 382.65 6.76953 384.26 6.76953ZM382.24 15.5995H386.2V38.5995H382.24V15.5995Z"
        fill="white"
      />
      <path
        d="M408.42 38.0096C407.04 38.7496 404.92 39.0696 402.81 39.0696C394.62 39.0696 390.8 34.0996 390.8 27.0596C390.8 20.0196 394.62 15.1396 402.81 15.1396C404.88 15.1396 406.49 15.4196 408.28 16.2396V19.9196C406.81 19.2296 405.24 18.8196 403.08 18.8196C397.1 18.8196 394.66 22.5896 394.66 27.0496C394.66 31.5096 397.14 35.2796 403.17 35.2796C405.52 35.2796 406.99 34.9596 408.41 34.4496V37.9896L408.42 38.0096Z"
        fill="white"
      />
      <path
        d="M420.14 39.0696C416.69 39.0696 413.88 38.2896 412.14 37.3696V33.1796C414.12 34.3296 417.43 35.4296 420.33 35.4296C423.23 35.4296 424.93 34.1896 424.93 32.3897C424.93 30.5897 423.6 29.6296 419.23 28.5696C414.12 27.3296 411.96 25.3496 411.96 21.5796C411.96 17.5796 415.04 15.1396 420.29 15.1396C423.28 15.1396 425.99 15.8796 427.7 16.7996V20.8896C424.94 19.5096 422.69 18.7696 420.25 18.7696C417.35 18.7696 415.79 19.7796 415.79 21.5796C415.79 23.1896 416.89 24.1996 421.13 25.2096C426.24 26.4496 428.81 28.3396 428.81 32.3396C428.81 36.3396 426.33 39.0596 420.16 39.0596L420.14 39.0696Z"
        fill="white"
      />
      <path
        d="M449.29 39.8101H445.29V29.8101H449.29V39.8101Z"
        fill="url(#paint0_linear_1052_8380)"
      />
      <path
        d="M465.29 39.8101H461.29V26.8101H465.29V39.8101Z"
        fill="url(#paint1_linear_1052_8380)"
      />
      <path
        d="M457.28 39.8101H453.28V21.8101H457.28V39.8101Z"
        fill="url(#paint2_linear_1052_8380)"
      />
      <path
        d="M473.28 39.8101H469.28V19.8101H473.28V39.8101Z"
        fill="url(#paint3_linear_1052_8380)"
      />
      <path
        d="M443.7 25.2199L440.87 22.3899L451 12.2599C452.78 10.4799 455.61 10.2999 457.61 11.8499L462.08 15.3299C462.68 15.7899 463.53 15.7399 464.06 15.2099L473.88 5.3999L476.71 8.2299L466.58 18.3599C464.8 20.1399 461.97 20.3199 459.97 18.7699L455.5 15.2899C454.9 14.8299 454.05 14.8799 453.52 15.4099L443.7 25.2199Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1052_8380"
        x1="447.29"
        y1="29.8101"
        x2="447.29"
        y2="39.8101"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.92" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_8380"
        x1="463.29"
        y1="39.8101"
        x2="463.29"
        y2="26.8101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_8380"
        x1="455.28"
        y1="39.8101"
        x2="455.28"
        y2="21.8101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1052_8380"
        x1="471.28"
        y1="39.8101"
        x2="471.28"
        y2="19.8101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <clipPath id="clip0_1052_8380">
        <rect width="477" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
